 class InstagramFollowBanner extends HTMLElement {
  constructor() {
    super();
    this.cookieName = `instagram-banner-${this.id}-dismissed`;
  }

  connectedCallback() {
    if (Shopify && Shopify.designMode) return;

    if (getCookie(this.cookieName) === "true") return;

    this.triggerType = this.dataset.trigger;
    this.delay = parseInt(this.dataset.delay, 10) * 1000;
    this.scrollPercentage = parseInt(this.dataset.scroll, 10);
    this.frequencyDays = parseInt(this.dataset.frequency, 10) || 7;

    this.buttonClose = this.querySelector(".js-button-close");
    this.buttonFollow = this.querySelector(".js-button-follow");

    this.buttonClose.addEventListener("click", this.dismiss.bind(this));
    this.buttonFollow.addEventListener("click", this.dismiss.bind(this));

    if (this.triggerType === "scroll") {
      this.setupScrollTrigger();
    } else {
      this.setupDelayTrigger();
    }
  }

  setupDelayTrigger() {
    this.timeoutId = setTimeout(() => this.show(), this.delay);
  }

  setupScrollTrigger() {
    this.onScroll = () => {
      const scrolled =
        (window.scrollY /
          (document.documentElement.scrollHeight - window.innerHeight)) *
        100;

      if (scrolled >= this.scrollPercentage) {
        this.show();
        window.removeEventListener("scroll", this.onScroll);
      }
    };

    window.addEventListener("scroll", this.onScroll, { passive: true });
  }

  show() {
    this.classList.add("instagram-follow-banner--visible");
  }

  dismiss() {
    setCookie(this.cookieName, "true", this.frequencyDays);
    this.classList.remove("instagram-follow-banner--visible");
    if (this.onScroll) window.removeEventListener("scroll", this.onScroll);
    if (this.timeoutId) clearTimeout(this.timeoutId);
  }
}

customElements.define("instagram-follow-banner", InstagramFollowBanner);
